export default __webpack_public_path__ + "9a49e280627c23c89c3018589636b2f0.png";